require('./sass/bootstrap.scss');
require('./sass/main.scss');

window.jQuery = require('jquery');
window.$ = require('jquery');

require('./js/bootstrap.js');


/*****************
 ** WEBPACK FOOTER
 ** ./entry-normal.js
 ** module id = 0
 ** module chunks = 3
 **/